import './SectionHeaderComponent.scss';

/**
 * Header component to display a line and title for sections in the symbol details view
 * @param {string} title - The title to display.
 * @returns {JSX.Element} The rendered header component.
 */
const HeaderComponent = ({ title }) => {
  return (
    <div className="header-container">
      <div className="header-line">
        <div className="header-line-golden"></div>
        <div className="header-line-gray"></div>
      </div>
      <div className="header-title">{title}</div>
    </div>
  );
};

export default HeaderComponent;
